import cx from 'classnames'
import Image from 'next/image'

import { type SanityImageFragment } from '@data/sanity/queries/types/image'
import { getBasicImageLoader } from '@lib/image'

import Photo from '@components/photo'

interface OptionThumbnailProps {
  photo: SanityImageFragment | string
  alt?: string
  active?: boolean
  onClick?: () => void
}

const OptionThumbnail = ({
  photo,
  alt,
  active,
  onClick,
}: OptionThumbnailProps) => {
  return (
    <button
      onClick={onClick}
      className={cx(
        'shrink-0 relative w-[64px] h-[64px]',
        active ? 'border-black border-2' : 'border',
      )}
    >
      {typeof photo === 'string' && (
        <Image
          src={photo}
          alt={alt ?? ''}
          width={64}
          height={64}
          loader={getBasicImageLoader}
          className="p-1 absolute inset-0"
        />
      )}
      {typeof photo !== 'string' && (
        <Photo image={photo} height={64} width={64} fill imageClassName="p-1" />
      )}
    </button>
  )
}

export default OptionThumbnail
